import React from "react"
import styles from "./index.module.scss"

interface DialogSkillProps {
    text: string
}
export const DialogSkill: React.FC<DialogSkillProps> = ({ text }) => {
    return (
        <div className={styles.dialogSkill}>
            <div className={styles.dialogSkillText}>{text}</div>
        </div>
    )
}
